<salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>
<div fxLayout="row" fxLayout.lt-md="column" style="min-height: 100%">
  <!-- Desktop stylist details -->
  <mat-card
    class="mat-elevation-z1"
    class="smc-stylist-card"
    *ngIf="stylist"
    fxShow.xs="false"
    fxShow.sm="false"
  >
    <img
      class="smc-stylist-photo"
      fxShow.xs="false"
      fxShow.sm="false"
      mat-card-image
      *ngIf="stylist.getPhotoUrl() != undefined && stylist.getPhotoUrl() != ''"
      [alt]="stylist.getFirstName() + ' ' + stylist.getLastName()"
      src="https://salonmonster.com/userfiles/profile_pics/{{
        stylist.getPhotoUrl()
      }}"
    />
    <mat-card-title
      fxShow.xs="false"
      fxShow.sm="false"
      class="smc-stylist-name"
    >
      {{ stylist.getFirstName() }} {{ stylist.getLastName() }}</mat-card-title
    >
    <mat-card-subtitle>{{ stylist.getTitle() }}</mat-card-subtitle>
    <mat-card-subtitle fxShow.xs="false" fxShow.sm="false">
      <div>
        <svg
          *ngIf="stylist['socialMediaLinks']['facebook']"
          (click)="navigate(stylist['socialMediaLinks']['facebook'])"
          tappable
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-facebook smc-social-icon"
          viewBox="0 0 16 16"
        >
          <path
            d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"
          />
        </svg>

        <svg
          *ngIf="stylist['socialMediaLinks']['twitter']"
          (click)="navigate(stylist['socialMediaLinks']['twitter'])"
          tappable
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-twitter-x smc-social-icon"
          viewBox="0 0 16 16"
        >
          <path
            d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"
          />
        </svg>

        <svg
          *ngIf="stylist['socialMediaLinks']['instagram']"
          (click)="navigate(stylist['socialMediaLinks']['instagram'])"
          tappable
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-instagram smc-social-icon"
          viewBox="0 0 16 16"
        >
          <path
            d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"
          />
        </svg>

        <svg
          *ngIf="stylist['socialMediaLinks']['googleMyBusiness']"
          (click)="navigate(stylist['socialMediaLinks']['googleMyBusiness'])"
          tappable
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-google smc-social-icon"
          viewBox="0 0 16 16"
        >
          <path
            d="M15.545 6.558a9.4 9.4 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.7 7.7 0 0 1 5.352 2.082l-2.284 2.284A4.35 4.35 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.8 4.8 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.7 3.7 0 0 0 1.599-2.431H8v-3.08z"
          />
        </svg>

        <svg
          *ngIf="stylist['socialMediaLinks']['tiktok']"
          (click)="navigate(stylist['socialMediaLinks']['tiktok'])"
          tappable
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-tiktok smc-social-icon"
          viewBox="0 0 16 16"
        >
          <path
            d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3z"
          />
        </svg>

        <svg
          *ngIf="stylist['socialMediaLinks']['pinterest']"
          (click)="navigate(stylist['socialMediaLinks']['pinterest'])"
          tappable
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-pinterest smc-social-icon"
          viewBox="0 0 16 16"
        >
          <path
            d="M8 0a8 8 0 0 0-2.915 15.452c-.07-.633-.134-1.606.027-2.297.146-.625.938-3.977.938-3.977s-.239-.479-.239-1.187c0-1.113.645-1.943 1.448-1.943.682 0 1.012.512 1.012 1.127 0 .686-.437 1.712-.663 2.663-.188.796.4 1.446 1.185 1.446 1.422 0 2.515-1.5 2.515-3.664 0-1.915-1.377-3.254-3.342-3.254-2.276 0-3.612 1.707-3.612 3.471 0 .688.265 1.425.595 1.826a.24.24 0 0 1 .056.23c-.061.252-.196.796-.222.907-.035.146-.116.177-.268.107-1-.465-1.624-1.926-1.624-3.1 0-2.523 1.834-4.84 5.286-4.84 2.775 0 4.932 1.977 4.932 4.62 0 2.757-1.739 4.976-4.151 4.976-.811 0-1.573-.421-1.834-.919l-.498 1.902c-.181.695-.669 1.566-.995 2.097A8 8 0 1 0 8 0"
          />
        </svg>

        <svg
          *ngIf="stylist['socialMediaLinks']['yelp']"
          (click)="navigate(stylist['socialMediaLinks']['yelp'])"
          tappable
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-yelp smc-social-icon"
          viewBox="0 0 16 16"
        >
          <path
            d="m4.188 10.095.736-.17.073-.02A.813.813 0 0 0 5.45 8.65a1 1 0 0 0-.3-.258 3 3 0 0 0-.428-.198l-.808-.295a76 76 0 0 0-1.364-.493C2.253 7.3 2 7.208 1.783 7.14c-.041-.013-.087-.025-.124-.038a2.1 2.1 0 0 0-.606-.116.72.72 0 0 0-.572.245 2 2 0 0 0-.105.132 1.6 1.6 0 0 0-.155.309c-.15.443-.225.908-.22 1.376.002.423.013.966.246 1.334a.8.8 0 0 0 .22.24c.166.114.333.129.507.141.26.019.513-.045.764-.103l2.447-.566zm8.219-3.911a4.2 4.2 0 0 0-.8-1.14 1.6 1.6 0 0 0-.275-.21 2 2 0 0 0-.15-.073.72.72 0 0 0-.621.031c-.142.07-.294.182-.496.37-.028.028-.063.06-.094.089-.167.156-.353.35-.574.575q-.51.516-1.01 1.042l-.598.62a3 3 0 0 0-.298.365 1 1 0 0 0-.157.364.8.8 0 0 0 .007.301q0 .007.003.013a.81.81 0 0 0 .945.616l.074-.014 3.185-.736c.251-.058.506-.112.732-.242.151-.088.295-.175.394-.35a.8.8 0 0 0 .093-.313c.05-.434-.178-.927-.36-1.308M6.706 7.523c.23-.29.23-.722.25-1.075.07-1.181.143-2.362.201-3.543.022-.448.07-.89.044-1.34-.022-.372-.025-.799-.26-1.104C6.528-.077 5.644-.033 5.04.05q-.278.038-.553.104a8 8 0 0 0-.543.149c-.58.19-1.393.537-1.53 1.204-.078.377.106.763.249 1.107.173.417.41.792.625 1.185.57 1.036 1.15 2.066 1.728 3.097.172.308.36.697.695.857q.033.015.068.025c.15.057.313.068.469.032l.028-.007a.8.8 0 0 0 .377-.226zm-.276 3.161a.74.74 0 0 0-.923-.234 1 1 0 0 0-.145.09 2 2 0 0 0-.346.354c-.026.033-.05.077-.08.104l-.512.705q-.435.591-.861 1.193c-.185.26-.346.479-.472.673l-.072.11c-.152.235-.238.406-.282.559a.7.7 0 0 0-.03.314c.013.11.05.217.108.312q.046.07.1.138a1.6 1.6 0 0 0 .257.237 4.5 4.5 0 0 0 2.196.76 1.6 1.6 0 0 0 .349-.027 2 2 0 0 0 .163-.048.8.8 0 0 0 .278-.178.7.7 0 0 0 .17-.266c.059-.147.098-.335.123-.613l.012-.13c.02-.231.03-.502.045-.821q.037-.735.06-1.469l.033-.87a2.1 2.1 0 0 0-.055-.623 1 1 0 0 0-.117-.27Zm5.783 1.362a2.2 2.2 0 0 0-.498-.378l-.112-.067c-.199-.12-.438-.246-.719-.398q-.644-.353-1.295-.695l-.767-.407c-.04-.012-.08-.04-.118-.059a2 2 0 0 0-.466-.166 1 1 0 0 0-.17-.018.74.74 0 0 0-.725.616 1 1 0 0 0 .01.293c.038.204.13.406.224.583l.41.768q.341.65.696 1.294c.152.28.28.52.398.719q.036.057.068.112c.145.239.261.39.379.497a.73.73 0 0 0 .596.201 2 2 0 0 0 .168-.029 1.6 1.6 0 0 0 .325-.129 4 4 0 0 0 .855-.64c.306-.3.577-.63.788-1.006q.045-.08.076-.165a2 2 0 0 0 .051-.161q.019-.083.029-.168a.8.8 0 0 0-.038-.327.7.7 0 0 0-.165-.27"
          />
        </svg>
      </div>
      <div>
        {{ stylist.getBio() }}
      </div>
    </mat-card-subtitle>
    <mat-card-header fxShow="false" fxShow.xs="true" fxShow.sm="true">
      <div fxLayout="column" style="min-height: 100%">
        <img
          *ngIf="
            stylist.getPhotoUrl() != undefined && stylist.getPhotoUrl() != ''
          "
          [alt]="stylist.getFirstName() + ' ' + stylist.getLastName()"
          src="https://salonmonster.com/userfiles/profile_pics/{{
            stylist.getPhotoUrl()
          }}"
        />
        <mat-card-title>
          {{ stylist.getFirstName() }}
          {{ stylist.getLastName() }}</mat-card-title
        >
        <mat-card-subtitle>{{ stylist.getBio() }}</mat-card-subtitle>
      </div>
    </mat-card-header>

    <mat-card-content
      class="smc-stylist-bookingintro"
      [innerHtml]="stylist.getBookingIntro()"
    >
    </mat-card-content>
    <mat-card-content
      sm-pale
      fxShow.xs="false"
      fxShow.sm="false"
      class="smc-cancellationpolicy"
    >
      <mat-icon style="font-size: 18px; height: 18px; width: 18px"
        >turned_in_not</mat-icon
      >
      <span [innerHtml]="stylist.getCancellationPolicy()"> </span>
    </mat-card-content>
  </mat-card>
  <!-- Mobile stlist details -->
  <mat-card
    fxShow.md="false"
    fxShow.lg="false"
    fxShow.xl="false"
    class="smc-stylist-card"
    *ngIf="stylist"
  >
    <div>
      <img
        mat-card-avatar
        class="smc-stylist-photo smc-avatar-large"
        *ngIf="
          stylist.getPhotoUrl() != undefined && stylist.getPhotoUrl() != ''
        "
        [alt]="stylist.getFirstName() + ' ' + stylist.getLastName()"
        src="https://salonmonster.com/userfiles/profile_pics/{{
          stylist.getPhotoUrl()
        }}"
      />
    </div>
    <div>
      <div fxLayout="column" style="min-height: 100%">
        <mat-card-title>
          {{ stylist.getFirstName() }}
          {{ stylist.getLastName() }}</mat-card-title
        >
        <mat-card-subtitle>{{ stylist.getTitle() }}</mat-card-subtitle>
        <mat-card-subtitle>
          <div>
            <svg
              *ngIf="stylist['socialMediaLinks']['facebook']"
              (click)="navigate(stylist['socialMediaLinks']['facebook'])"
              tappable
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-facebook smc-social-icon"
              viewBox="0 0 16 16"
            >
              <path
                d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"
              />
            </svg>

            <svg
              *ngIf="stylist['socialMediaLinks']['twitter']"
              (click)="navigate(stylist['socialMediaLinks']['twitter'])"
              tappable
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-twitter-x smc-social-icon"
              viewBox="0 0 16 16"
            >
              <path
                d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"
              />
            </svg>

            <svg
              *ngIf="stylist['socialMediaLinks']['instagram']"
              (click)="navigate(stylist['socialMediaLinks']['instagram'])"
              tappable
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-instagram smc-social-icon"
              viewBox="0 0 16 16"
            >
              <path
                d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"
              />
            </svg>

            <svg
              *ngIf="stylist['socialMediaLinks']['googleMyBusiness']"
              (click)="
                navigate(stylist['socialMediaLinks']['googleMyBusiness'])
              "
              tappable
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-google smc-social-icon"
              viewBox="0 0 16 16"
            >
              <path
                d="M15.545 6.558a9.4 9.4 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.7 7.7 0 0 1 5.352 2.082l-2.284 2.284A4.35 4.35 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.8 4.8 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.7 3.7 0 0 0 1.599-2.431H8v-3.08z"
              />
            </svg>

            <svg
              *ngIf="stylist['socialMediaLinks']['tiktok']"
              (click)="navigate(stylist['socialMediaLinks']['tiktok'])"
              tappable
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-tiktok smc-social-icon"
              viewBox="0 0 16 16"
            >
              <path
                d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3z"
              />
            </svg>

            <svg
              *ngIf="stylist['socialMediaLinks']['pinterest']"
              (click)="navigate(stylist['socialMediaLinks']['pinterest'])"
              tappable
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-pinterest smc-social-icon"
              viewBox="0 0 16 16"
            >
              <path
                d="M8 0a8 8 0 0 0-2.915 15.452c-.07-.633-.134-1.606.027-2.297.146-.625.938-3.977.938-3.977s-.239-.479-.239-1.187c0-1.113.645-1.943 1.448-1.943.682 0 1.012.512 1.012 1.127 0 .686-.437 1.712-.663 2.663-.188.796.4 1.446 1.185 1.446 1.422 0 2.515-1.5 2.515-3.664 0-1.915-1.377-3.254-3.342-3.254-2.276 0-3.612 1.707-3.612 3.471 0 .688.265 1.425.595 1.826a.24.24 0 0 1 .056.23c-.061.252-.196.796-.222.907-.035.146-.116.177-.268.107-1-.465-1.624-1.926-1.624-3.1 0-2.523 1.834-4.84 5.286-4.84 2.775 0 4.932 1.977 4.932 4.62 0 2.757-1.739 4.976-4.151 4.976-.811 0-1.573-.421-1.834-.919l-.498 1.902c-.181.695-.669 1.566-.995 2.097A8 8 0 1 0 8 0"
              />
            </svg>

            <svg
              *ngIf="stylist['socialMediaLinks']['yelp']"
              (click)="navigate(stylist['socialMediaLinks']['yelp'])"
              tappable
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-yelp smc-social-icon"
              viewBox="0 0 16 16"
            >
              <path
                d="m4.188 10.095.736-.17.073-.02A.813.813 0 0 0 5.45 8.65a1 1 0 0 0-.3-.258 3 3 0 0 0-.428-.198l-.808-.295a76 76 0 0 0-1.364-.493C2.253 7.3 2 7.208 1.783 7.14c-.041-.013-.087-.025-.124-.038a2.1 2.1 0 0 0-.606-.116.72.72 0 0 0-.572.245 2 2 0 0 0-.105.132 1.6 1.6 0 0 0-.155.309c-.15.443-.225.908-.22 1.376.002.423.013.966.246 1.334a.8.8 0 0 0 .22.24c.166.114.333.129.507.141.26.019.513-.045.764-.103l2.447-.566zm8.219-3.911a4.2 4.2 0 0 0-.8-1.14 1.6 1.6 0 0 0-.275-.21 2 2 0 0 0-.15-.073.72.72 0 0 0-.621.031c-.142.07-.294.182-.496.37-.028.028-.063.06-.094.089-.167.156-.353.35-.574.575q-.51.516-1.01 1.042l-.598.62a3 3 0 0 0-.298.365 1 1 0 0 0-.157.364.8.8 0 0 0 .007.301q0 .007.003.013a.81.81 0 0 0 .945.616l.074-.014 3.185-.736c.251-.058.506-.112.732-.242.151-.088.295-.175.394-.35a.8.8 0 0 0 .093-.313c.05-.434-.178-.927-.36-1.308M6.706 7.523c.23-.29.23-.722.25-1.075.07-1.181.143-2.362.201-3.543.022-.448.07-.89.044-1.34-.022-.372-.025-.799-.26-1.104C6.528-.077 5.644-.033 5.04.05q-.278.038-.553.104a8 8 0 0 0-.543.149c-.58.19-1.393.537-1.53 1.204-.078.377.106.763.249 1.107.173.417.41.792.625 1.185.57 1.036 1.15 2.066 1.728 3.097.172.308.36.697.695.857q.033.015.068.025c.15.057.313.068.469.032l.028-.007a.8.8 0 0 0 .377-.226zm-.276 3.161a.74.74 0 0 0-.923-.234 1 1 0 0 0-.145.09 2 2 0 0 0-.346.354c-.026.033-.05.077-.08.104l-.512.705q-.435.591-.861 1.193c-.185.26-.346.479-.472.673l-.072.11c-.152.235-.238.406-.282.559a.7.7 0 0 0-.03.314c.013.11.05.217.108.312q.046.07.1.138a1.6 1.6 0 0 0 .257.237 4.5 4.5 0 0 0 2.196.76 1.6 1.6 0 0 0 .349-.027 2 2 0 0 0 .163-.048.8.8 0 0 0 .278-.178.7.7 0 0 0 .17-.266c.059-.147.098-.335.123-.613l.012-.13c.02-.231.03-.502.045-.821q.037-.735.06-1.469l.033-.87a2.1 2.1 0 0 0-.055-.623 1 1 0 0 0-.117-.27Zm5.783 1.362a2.2 2.2 0 0 0-.498-.378l-.112-.067c-.199-.12-.438-.246-.719-.398q-.644-.353-1.295-.695l-.767-.407c-.04-.012-.08-.04-.118-.059a2 2 0 0 0-.466-.166 1 1 0 0 0-.17-.018.74.74 0 0 0-.725.616 1 1 0 0 0 .01.293c.038.204.13.406.224.583l.41.768q.341.65.696 1.294c.152.28.28.52.398.719q.036.057.068.112c.145.239.261.39.379.497a.73.73 0 0 0 .596.201 2 2 0 0 0 .168-.029 1.6 1.6 0 0 0 .325-.129 4 4 0 0 0 .855-.64c.306-.3.577-.63.788-1.006q.045-.08.076-.165a2 2 0 0 0 .051-.161q.019-.083.029-.168a.8.8 0 0 0-.038-.327.7.7 0 0 0-.165-.27"
              />
            </svg>
          </div>
          <div>
            {{ stylist.getBio() }}
          </div>
        </mat-card-subtitle>
      </div>

      <mat-card-content
        class="smc-stylist-bookingintro"
        [innerHtml]="stylist.getBookingIntro()"
      >
      </mat-card-content>
      <mat-card-content sm-pale class="smc-cancellationpolicy">
        <!-- <mat-icon style='font-size:18px;height:18px;width:18px;'>turned_in_not</mat-icon> -->
        <span [innerHtml]="stylist.getCancellationPolicy()"> </span>
      </mat-card-content>
    </div>
  </mat-card>
  <div fxFlex="2 1 auto" *ngIf="!isLoading">
    <mat-accordion>
      <ng-container *ngFor="let serviceCategory of serviceCategories">
        <mat-expansion-panel
          *ngIf="serviceCategory.getBookableServiceDefinitions().length > 0"
          [expanded]="bookableCategoryCount === 1"
          class="smc-service-category-panel"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ serviceCategory.getCategoryName() }}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-nav-list>
            <ng-container
              *ngFor="
                let serviceDefinition of serviceCategory.getBookableServiceDefinitions()
              "
            >
              <mat-list-item
                class="smc-service-list-item"
                (click)="serviceSelect(serviceDefinition)"
              >
                <h2
                  class="smc-clickable-text smc-service-name"
                  tappable
                  mat-line
                >
                  {{ serviceDefinition.getServiceName() }}
                </h2>
                <span
                  mat-line
                  class="smc-service-description"
                  *ngIf="serviceDefinition.getDescription() !== 'undefined' && serviceDefinition.getDescription() !== '' && serviceDefinition.getDescription() !== ' ' && serviceDefinition.getDescription() !== null"
                  [innerHtml]="
                    serviceDefinition.getDescription() | safe: 'html'
                  "
                ></span>
                <p mat-line class="smc-service-details">
                  <span *ngIf="stylist.getHidePrices() !== 1 && serviceDefinition.getStartingAt() == 1">{{ 'BOOKINGS.STARTING_AT' | translate }}</span>
                  {{
                    stylist.getHidePrices() !== 1
                      ? (serviceDefinition.getPrice() | salonMonsterCurrency) +
                        ', '
                      : ''
                  }}
                  <span *ngIf="stylist.getHideDurations() !== 1">{{ 'BOOKINGS.ABOUT' | translate }} {{ serviceDefinition.getDuration() + serviceDefinition.getProcessDuration() + serviceDefinition.getFinishDuration() | SalonMonsterFormatDurationPipe }}</span>
                </p>
              </mat-list-item>
            </ng-container>
          </mat-nav-list>
        </mat-expansion-panel>
      </ng-container>
    </mat-accordion>
  </div>
</div>
